// extracted by mini-css-extract-plugin
export default {"display":"FileDisplayPDF_display__v4fOo"};